module.exports = __webpack_public_path__ + "static/media/ksarLoader.4bced611.gif";